import React, { useCallback } from 'react';
import { Space, Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setAutoSortEnabled, setGreenBarEnabled } from '@store/noc/base/actions';
import { ToggleText, Header } from './styled';
import { autoSortEnabledSelector, greenBarEnabledSelector } from '@store/noc/base/selectors';

function NOCSetting() {
  const dispatch = useDispatch();
  const isAutoSortEnabled = useSelector(autoSortEnabledSelector);
  const isGreenBarEnabled = useSelector(greenBarEnabledSelector);

  const handleSortToggle = useCallback(
    (checked) => {
      dispatch(setAutoSortEnabled(checked));
    },
    [dispatch],
  );

  const handleGreenBarToggle = useCallback(
    (checked) => {
      dispatch(setGreenBarEnabled(checked));
    },
    [dispatch],
  );

  return (
    <Space direction="vertical">
      <Header>NOC</Header>
      <div>
        <Switch checked={isAutoSortEnabled} onChange={handleSortToggle} />
        <ToggleText>Auto Sort</ToggleText>
      </div>
      <div>
        <Switch checked={isGreenBarEnabled} onChange={handleGreenBarToggle} />
        <ToggleText>Green Bars</ToggleText>
      </div>
    </Space>
  );
}

export default NOCSetting;
